import 'bootstrap/dist/css/bootstrap.css';
import Col from 'react-bootstrap/Col';

const sectionC= () => {
    return (  
        <Col md="8" id='section'>
            <div id='sectionheader'>
                <h4>Co to jest OFR?</h4>
                <h5>OFR to jednocześnie nasza drużyna oraz zmodowany serwer, nasz kanał youtube i inne media społecznościowe!</h5>
                <br />
                <h4>Jak moge dołączyć?</h4>
                <h5>Wszystkie informacje znajdziesz na oficjalnym discordzie serwera, tam również są modyfikacje do pobrania, ip serwera oraz moderatorzy którzy ci pomogą w przypadku problemów :)</h5>
                <br />
                <h4>Jakie edycje?</h4>    
                <h5>Mapa serwera jest resetowana co pół roku a niektóre modyfikacje wymieniamy na inne. Dodatkowo co edycje dostarczymy różne nowości aby rozgrywka była lepsza i mniej monotoniczna. Po skończeniu edycji mapę można pobrać i grać lokalnie u siebie!</h5>
                <br />
                <h4>Czy trzeba płacić?</h4>
                <h5>Wstęp jest całkowicie za darmo, a fundusze z uzbieranych opcjonalnych zakupów rang lub najzwyklejszych donacji jest przekazywana na serwer oraz jego rozwijanie!.</h5>
                <br />
                <h4>Jakie modyfikacje?</h4>
                <h5>Najważniejsze z nich to "Create" i "Farmer's Delight" - obydwie z licznymi dodatkami, "Artifacts", Seria "Better" od YUNG i inne! Cała paczka modów jest dostępna na discord.</h5>
                <br />
                <h4>Co oferuje serwer discord?</h4>
                <h5>Kontakt z właścicielem, społecznością, moderatorami czy developerami, możliwość uczestniczenia w głosowaniach, wydarzeniach lub bycie zaproszonym na filmiki serwerowe, mamy też discordowy rynek graczy i kanał z mediami!</h5>
                <br />
            </div>
        </Col>
    );
}
 
export default sectionC;